import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Newsletter from "./Newsletter";
import NewsLetterSend from "./NewsLetterSend";
import NewsTemplateList from "./NewsTemplateList";
import NewsLetterSendPreview from "./NewsLetterSendPreview";
import NewsletterEditor from "./NewsletterEditor";
// import SentPreview from "./SentPreview";
// import EditPreview from "./EditPreview";

function NewsletterRouter() {
    return (
        <Routes>
            <Route path="/" element={<NewsTemplateList />} />
            <Route path="editor" element={<NewsletterEditor />} />

            <Route path="create" element={<NewsletterEditor />} />
            <Route path="send/:id" element={<NewsLetterSend />} />
            <Route path="list" element={<NewsTemplateList />} />
            <Route path="preview/:id" element={<NewsLetterSendPreview />} />
            {/* <Route path="edit-preview/:id" element={<EditPreview />} /> */}
            <Route
                path="*"
                element={<Navigate to="/dashboard/newsletter" replace />}
            />
        </Routes>
    );
}

export default NewsletterRouter;
